<div class="interactions-container">
    <div class="total">{{ total | number }}</div>
  </div>